import { Datatype } from '@framework/engine/schema/expressions/datatype/Datatype.ts';
import {
  type IReference,
  ReferenceType,
} from '@framework/engine/schema/expressions/references/IReference.ts';
import { type IReferencePath } from '@framework/engine/schema/expressions/references/IReferencePath.ts';
import { type IProvinceWidget } from './IProvinceWidget.ts';

export function getProvinceWidgetReference(
  path: IReferencePath,
  widget: IProvinceWidget,
): IReference {
  return {
    type: ReferenceType.Widget,
    widgetType: widget.type,
    path,
    id: widget.id,
    code: widget.code,
    label: widget.code,
    field: {
      type: Datatype.Hidden,
    },
  };
}
